<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-1">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div
                  class="flex justify-content-between text-3xl mb-0 card font-bold"
                >
                  <div>Complaints Details</div>
                  <div v-if="pageReady">
                    <div class="flex justify-content-end">
                      <div v-if="item.status == 'opened'" class="">
                        <Menubar
                          class="p-0 border-0"
                          ref="actionMenu"
                          :model="getComplaintActionMenu(item)"
                        >
                          <template #item="{ item }">
                            <Button
                              :icon="item.icon"
                              :label="item.label"
                              class="ml-2"
                              :class="item.button"
                              @click="item.command"
                            ></Button>
                          </template>
                        </Menubar>
                      </div>
                      <div class="">
                        <Menubar
                          class="p-0 border-0"
                          ref="actionMenu"
                          :model="getActionMenuModel(item)"
                        >
                          <template #item="{ item }">
                            <Button
                              :icon="item.icon"
                              :label="item.label"
                              class="ml-2"
                              :class="item.button"
                              @click="item.command"
                            ></Button>
                          </template>
                        </Menubar>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="">
                <Breadcrumb
                  :home="{
                    icon: 'pi pi-arrow-left text-lg mr-3',
                    label: 'Back',
                    command: () => {
                      $router.go(-1);
                    },
                  }"
                  :model="[
                    {
                      label: 'Complaints Details',
                      to: '/complaints',
                    },
                  ]"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="col-12 md:col-5 comp-grid">
            <div class="">
              <div class="">
                <div>
                  <div class="relative-position" style="min-height: 100px">
                    <template v-if="pageReady">
                      <div class="grid">
                        <div class="col-12">
                          <div class="" :class="{ card: !isSubPage }">
                            <div class="grid align-items-center">
                              <div class="col">Ticket Number:</div>
                              <div class="col font-bold">
                                {{ item.ticket_id }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Status:</div>
                              <div class="col font-bold">
                                <Tag
                                  v-if="item.status == 'opened'"
                                  class="bg-cyan-700"
                                  rounded
                                  :value="$utils.capitalize(item.status)"
                                ></Tag>
                                <Tag
                                  v-else-if="item.status == 'closed'"
                                  class="bg-green-400"
                                  rounded
                                  :value="$utils.capitalize(item.status)"
                                ></Tag>
                                <Tag
                                  v-else-if="item.status == 'prank'"
                                  class=""
                                  rounded
                                  severity="warning"
                                  :value="$utils.capitalize(item.status)"
                                ></Tag>
                                <Tag
                                  v-else
                                  class="bg-gray-500"
                                  rounded
                                  :value="$utils.capitalize(item.status)"
                                ></Tag>
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Severity:</div>
                              <div class="col font-bold">
                                {{ $utils.capitalize(item.severity) }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Source Of Complaint:</div>
                              <div class="col font-bold">
                                {{ item.source_of_complaint }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Complaint Type:</div>
                              <div class="col font-bold">
                                {{ $utils.capitalize(item.complaint_type) }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Customer Name(s):</div>
                              <div class="col font-bold">
                                <span v-if="item.customers_name"
                                  >{{ item.customers_name }} <br />
                                </span>
                                <span v-else>
                                  {{ item.clients_first_name }}</span
                                >
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Customer Telephone:</div>
                              <div class="col font-bold">
                                <Button
                                  class="p-button-link p-0 text-left"
                                  :label="item.client_id"
                                  target="__blank"
                                  v-if="item.client_id"
                                  @click="
                                    app.navigateTo(
                                      `/clients/view/${item.client_id}`,
                                      `_blank`
                                    )
                                  "
                                />
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Customer Account Number:</div>
                              <div class="col font-bold">
                                {{ item.clients_account_number }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Mobile App Account:</div>
                              <div class="col font-bold">
                                <Button
                                  class="p-button-link p-0 text-left"
                                  label="Click to view mobile app account details"
                                  v-if="item.customer_id"
                                  @click="
                                    app.navigateTo(
                                      `/customers/view/${item.customer_id}`,
                                      `_blank`
                                    )
                                  "
                                />
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Title:</div>
                              <div class="col font-bold">{{ item.title }}</div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Site Of Complaint:</div>
                              <div class="col font-bold">
                                {{ item.site_of_complaint }}
                              </div>
                            </div>
                            <hr v-if="$auth.canView('/cdr/list')" >
                            <div
                              v-if="$auth.canView('/cdr/list')"
                              class="grid align-items-center"
                            >
                              <div class="col">Playback Audio:</div>
                              <div class="col font-bold">
                                <Button
                                  class="p-button-link p-0 text-left"
                                  label="Click to see all playback audio files"
                                  @click="
                                    app.openPageDialog({
                                      page: 'cdr/list',
                                      url: `/cdr/index/cdr.complaint_id/${item.complaint_id}`,
                                      maximized: true,
                                      closeBtn: true,
                                      position: 'bottom',
                                    })
                                  "
                                />
                              </div>
                            </div>
                          </div>
                          <Accordion :multiple="true" :activeIndex="[0, 1, 2, 3]">
                            <AccordionTab header="Message/Description">
                              <span class="text-teal-500 font-bold">{{
                                item.message
                              }}</span>
                            </AccordionTab>
                            <AccordionTab header="Solution">
                              {{ item.solution }}
                            </AccordionTab>
                            <AccordionTab header="Action Taken">
                              {{ item.action_taken }}
                            </AccordionTab>
                            <AccordionTab header="Attached Files">
                              <image-viewer
                                image-size="large"
                                image-preview-size=""
                                :src="item.attached_files"
                                width="50px"
                                height="50px"
                                :num-display="5"
                              >
                              </image-viewer>
                            </AccordionTab>
                          </Accordion>
                          <div class="mt-3" :class="{ card: !isSubPage }">
                            <div class="grid align-items-center">
                              <div class="col">Created By:</div>
                              <div class="col font-bold">
                                <Button
                                  class="p-button-link p-0 text-left"
                                  label="Click to view staff details"
                                  v-if="item.created_by"
                                  @click="
                                    app.navigateTo(
                                      `/users/view/${item.created_by}`,
                                      `_blank`
                                    )
                                  "
                                />
                              </div>
                            </div>
                            <hr />
                            <!-- <div class="grid align-items-center">
                              <div class="col">Rating by Customer:</div>
                              <div class="col font-bold">
                                {{ item.rating }}
                                <Rating
                                  v-model="item.rating"
                                  :stars="4"
                                  readonly
                                  :cancel="false"
                                />
                              </div>
                            </div>
                            <hr /> -->
                            <div class="grid align-items-center">
                              <div class="col">Region:</div>
                              <div class="col font-bold">
                                {{ item.assigned_region }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">District:</div>
                              <div class="col font-bold">
                                {{ item.assigned_district }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Officer Handling:</div>
                              <div class="col font-bold">
                                {{ item.officer_handling }}
                              </div>
                            </div>
                            <hr />
                            <!-- <div class="grid align-items-center">
                              <div class="col">Assigned To:</div>
                              <div class="col font-bold">
                                <Button
                                  class="p-button-link p-0 text-left"
                                  label="Click to view staff details"
                                  v-if="item.assigned_to"
                                  @click="
                                    app.navigateTo(
                                      `/users/view/${item.assigned_to}`,
                                      `_blank`
                                    )
                                  "
                                />
                              </div>
                            </div>
                            <hr /> -->
                            <div class="grid align-items-center">
                              <div class="col">Date Created:</div>
                              <div
                                v-if="item.date_created"
                                class="col font-bold"
                              >
                                {{ $utils.humanDatetime(item.date_created) }}
                              </div>
                            </div>
                            <hr />
                            <!-- <div class="grid align-items-center">
                              <div class="col">Date Completed:</div>
                              <div
                                v-if="item.date_completed"
                                class="col font-bold"
                              >
                                {{ $utils.humanDatetime(item.date_completed) }}
                              </div>
                            </div>
                            <hr /> -->
                            <div class="grid align-items-center">
                              <div class="col">Last Updated:</div>
                              <div
                                v-if="item.date_updated"
                                class="col font-bold"
                              >
                                {{ $utils.humanDatetime(item.date_updated) }}
                              </div>
                            </div>
                            <hr />
                            <div class="flex justify-btween">
                              <SplitButton
                                class="p-button p-button-raised p-button-text p-button-sm"
                                :model="getActionMenuModel(item)"
                              >
                                <i></i>
                              </SplitButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-if="loading">
                      <div>
                        <table class="p-datatable-table w-full">
                          <tbody>
                            <tr v-for="n in 5" :key="n">
                              <td class="text-left" style="width: 100%">
                                <Skeleton height="4rem" class="m-2" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-3 comp-grid">
            <div
              v-if="item && item.client_id && auth.userDistrict == 'Call Center'"
              class="card py-0 px-0 flex justify-content-between bg-green-100 mb-3"
            >
              <div class="text-sm py-3 pl-3 font-bold">
                <span class=""> Call back customer</span>
              </div>
              <div class="py-2 mt-1 mr-2">
                <Button
                  label="Call Now"
                  icon="pi pi-phone"
                  class="p-button-sm p-button-success mx-1 py-1"
                  @click="
                    app.openCallBackDialog({
                      contact: `${item.client_id}`,
                      complaintId: `${item.complaint_id}`,
                      description: `You are about to call ${
                        item.customers_name || item.first_name
                      } (${item.client_id}). Do you want to continue?`,
                    })
                  "
                />
              </div>
            </div>
            <div v-if="pageReady" class="sticky-item">
              <div v-if="item.source_of_complaint == 'Mobile App'" class="">
                <div>
                  <ChatsListPage
                    ref="chatsListPage"
                    :limit="5"
                    field-name="chats.complaint_id"
                    :field-value="id"
                    :show-header="true"
                    :show-breadcrumbs="true"
                    :show-footer="true"
                    :complaint-id="item.complaint_id"
                    :complaint-status="item.status"
                    :customer-name="
                      item.customers_name || item.clients_first_name
                    "
                    :paginate="true"
                    v-if="pageReady"
                  >
                  </ChatsListPage>
                </div>
              </div>
              <div class="">
                <div>
                  <ActivitiesListPage
                    ref="activitiesListPage"
                    :limit="3"
                    field-name="activities.ticket_id"
                    :field-value="item.complaint_id"
                    :complaint-id="item.complaint_id"
                    :show-header="true"
                    :show-breadcrumbs="true"
                    :show-footer="true"
                    :paginate="true"
                    v-if="pageReady"
                  >
                  </ActivitiesListPage>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-4 comp-grid">
            <div class="">
              <div class="">
                <div v-if="pageReady">
                  <ComplaintsSublistPage
                    ref="complaintsListPage"
                    :limit="3"
                    field-name="complaints.client_id"
                    :field-value="item.client_id"
                    :complaint-id="item.complaint_id"
                    :show-header="true"
                    :show-breadcrumbs="true"
                    :show-footer="true"
                    :paginate="true"
                    v-if="pageReady"
                  >
                  </ComplaintsSublistPage>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { toRefs, onMounted } from "vue";
import { useStore } from "vuex";
import { utils } from "@/utils";
import { useApp } from "@/composables/app.js";
import { useAuth } from "@/composables/auth";
import { useViewPage } from "@/composables/viewpage.js";
import ActivitiesListPage from "../activities/list.vue";
import ChatsListPage from "../chats/list.vue";
import ComplaintsSublistPage from "../complaints/sublist.vue";
import { ApiService } from "@/services/api";
import { useConfirm } from "primevue/useconfirm";

const props = defineProps({
  id: [String, Number],
  primaryKey: {
    type: String,
    default: "complaint_id",
  },
  pageName: {
    type: String,
    default: "complaints",
  },
  routeName: {
    type: String,
    default: "complaintsview",
  },
  apiPath: {
    type: String,
    default: "complaints/view",
  },
  editButton: {
    type: Boolean,
    default: true,
  },
  deleteButton: {
    type: Boolean,
    default: true,
  },
  exportButton: {
    type: Boolean,
    default: true,
  },
  titleBeforeDelete: {
    type: String,
    default: "Delete record",
  },
  msgBeforeDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  msgAfterDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});
const app = useApp(props);
const auth = useAuth();
const confirm = useConfirm();
const store = useStore();
const page = useViewPage(props); // page hook
//page state
const {
  item, // current record from store - Object
  loading, // api loading state
  pageReady, // api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  apiUrl, // page current api path
  currentRecord, // current page record  - Object
} = page.computedProps;
//page methods
const {
  load, // load data from api
  deleteItem, // deleted current record
  exportPage, // export page records - args = (exportFormats, apiUrl, pageName)
  moveToNextRecord, // load next record from api
  moveToPreviousRecord, // load previous record from api
} = page.methods;
function getActionMenuModel(data) {
  return [
    {
      label: "Update Ticket",
      command: (event) => {
        app.openPageDialog({
          page: "complaints/edit",
          url: `/complaints/edit/${data.complaint_id}`,
          closeBtn: true,
          persistent: true,
          position: "bottom",
        });
      },
      icon: "pi pi-pencil",
      visible: auth.canView("complaints/edit"),
    },
  ];
}
function getComplaintActionMenu(data) {
  return [
    {
      label: "Close Ticket",
      button: "p-button-success",
      command: (event) => {
        updateComplaintStatus("closed", data);
      },
      icon: "pi pi-check-circle",
      visible: auth.canView("complaints/edit"),
    },
    {
      label: "Mark as Prank",
      button: "p-button-warning",
      command: (event) => {
        updateComplaintStatus("prank", data);
      },
      icon: "pi pi-exclamation-triangle",
      visible: auth.canView("complaints/edit"),
    },
  ];
}

async function updateComplaintStatus(status, data) {
  confirm.require({
    message: `You are about to ${
      status == "closed"
        ? "close this complaint ticket"
        : "mark this complaint as Prank"
    }. Click Yes to proceed`,
    header: "Confirm Action",
    icon: "pi pi-info-circle",
    accept: async () => {
      try {
        store.commit("app/setFullScreenLoading", true);
        let payload = { status: status };
        const response = await ApiService.post(
          `/complaints/update/${data.complaint_id}`,
          payload
        );
        const record = response.data;
        load();
        store.commit("app/setFullScreenLoading", false);
      } catch (err) {
        app.showPageRequestError(err);
        store.commit("app/setFullScreenLoading", false);
      }
    },
    reject: () => {
      //callback to execute when user rejects the action
    },
  });
}

onMounted(() => {
  const pageTitle = "Complaints Details";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
  load();
});
</script>
<style scoped></style>
